import { render, staticRenderFns } from "./CouponPop.vue?vue&type=template&id=0be6ebdf&"
import script from "./CouponPop.vue?vue&type=script&lang=js&"
export * from "./CouponPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports